/**
 * Seeded once from grantable-paths.json on 2026-10-08; edit by hand from here.
 *
 * Maintenance tools.
 */

import { folder } from '../builder';

export const maintenance = folder('Maintenance');
export const cashCountCategories = maintenance.tool('Cash Count Categories');
export const cashCountCategoriesCreateCashCountCategory = cashCountCategories.command('Create Cash Count Category');
export const cashCountCategoriesEditCashCountCategory = cashCountCategories.command('Edit Cash Count Category');
// Combo Boxes (combo-boxes intent, unit-03): the legacy paths, byte-identical. There is no Duplicate
// command (legacy's was dead). Activate and Inactivate share one command, as Task Types does.
export const comboBoxes = maintenance.tool('Combo Boxes');
export const comboBoxesActivateInactivateComboBox = comboBoxes.command('Activate/Inactivate Combo Box');
export const comboBoxesCreateComboBox = comboBoxes.command('Create Combo Box');
export const comboBoxesEditComboBox = comboBoxes.command('Edit Combo Box');
// Departments: legacy `DepartmentMaintenanceCommands.cs` paths (2026-10-12; replaced the Nova-only
// `Department Maintenance\View|WriteDepartment|WriteTitle`). Opening the tool needs the tool path;
// titles are edited inside the department editor, so they need Edit Department, as in legacy.
export const departments = maintenance.tool('Departments');
export const departmentsCreateDepartment = departments.command('Create Department');
export const departmentsEditDepartment = departments.command('Edit Department');
export const depositCategories = maintenance.tool('Deposit Categories');
// Deposit Categories: legacy `DepositCategoryCommands` paths, byte for byte (plan Q2, Q21, Q33). The four
// `Edit Deposit Category\...` children are legacy's section gates; Nova enforces `Main` and
// `Transaction Options` on the server, where legacy only greyed the fields. `System Options` is not
// declared: legacy never enforced it (plan Out of scope 10). Replaces the Nova-only `Edit Offsets`.
export const depositCategoriesCreateDepositCategory = depositCategories.command('Create Deposit Category');
export const depositCategoriesEditDepositCategory = depositCategories.command('Edit Deposit Category');
export const depositCategoriesEditDepositCategoryMain = depositCategoriesEditDepositCategory.command('Main');
export const depositCategoriesEditDepositCategoryTransactionOptions = depositCategoriesEditDepositCategory.command('Transaction Options');
export const depositCategoriesEditDepositCategoryAttributesTab = depositCategoriesEditDepositCategory.command('Attributes Tab');
export const depositCategoriesEditDepositCategoryOffsets = depositCategoriesEditDepositCategory.command('Offsets');
export const depositCategoriesDuplicateDepositCategory = depositCategories.command('Duplicate Deposit Category');
export const depositCategoriesActivateInactivateDepositCategory = depositCategories.command('Activate/Inactivate Deposit Category');
export const depositCategoryTypes = maintenance.tool('Deposit Category Types');
export const depositCategoryTypesActivateInactivateDepositCategoryType = depositCategoryTypes.command('Activate/Inactivate Deposit Category Type');
export const depositCategoryTypesCreateDepositCategoryType = depositCategoryTypes.command('Create Deposit Category Type');
export const depositCategoryTypesEditDepositCategoryType = depositCategoryTypes.command('Edit Deposit Category Type');
// Dropdown Filter Security (combo-boxes unit-07): legacy's hidden `Maintenance\Dropdown Filter Security\
// {DataCategory}\{FilterTypeCategory}` commands that gate each picker's "show all" checkbox. Nine paths,
// byte for byte. Legacy's Vault Location gate was inert and is not declared. The four Employee paths are
// enforced by `GET /dropdown-lookups/employees/hidden`, so they are not uiOnly; the other five gate
// client-side checkboxes only.
export const dropdownFilterSecurity = maintenance.folder('Dropdown Filter Security');
export const dfsComboBox = dropdownFilterSecurity.folder('Combo Box');
export const dfsComboBoxShowInactive = dfsComboBox.command('Show Inactive', {
  description: 'Show inactive combo box items in a picker.',
  uiOnly: true,
});
export const dfsEmployee = dropdownFilterSecurity.folder('Employee');
export const dfsEmployeeShowInactive = dfsEmployee.command('Show Inactive', {
  description: 'Show inactive employees in an employee picker.',
});
export const dfsEmployeeShowNonCashiers = dfsEmployee.command('Show Non-Cashiers', {
  description: 'Show employees who are not cashiers in a cashier picker.',
});
export const dfsEmployeeShowNonTipped = dfsEmployee.command('Show Non-Tipped', {
  description: 'Show employees who are not tipped employees in a tip picker.',
});
export const dfsEmployeeShowNonTippedOut = dfsEmployee.command('Show Non-Tipped-Out', {
  description: 'Show employees who are not tipped-out employees in a tip-out picker.',
});
export const dfsVaultShift = dropdownFilterSecurity.folder('Vault Shift');
export const dfsVaultShiftShowHistorical = dfsVaultShift.command('Show Historical', {
  description: 'Show shifts from closed game days in a vault shift picker.',
  uiOnly: true,
});
export const dfsDepositCategory = dropdownFilterSecurity.folder('Deposit Category');
export const dfsDepositCategoryShowInactive = dfsDepositCategory.command('Show Inactive', {
  description: 'Show inactive deposit categories in a picker.',
  uiOnly: true,
});
export const dfsDepositCategoryShowAllActive = dfsDepositCategory.command('Show All Active', {
  description: 'Show every active deposit category, including ones hidden from the picker by context.',
  uiOnly: true,
});
export const dfsDepositCategorySubcategory = dropdownFilterSecurity.folder('Deposit Category Subcategory');
export const dfsDepositCategorySubcategoryShowInactive = dfsDepositCategorySubcategory.command('Show Inactive', {
  description: 'Show inactive deposit category subcategories in a picker.',
  uiOnly: true,
});
export const documentDesigner = maintenance.tool('Document Designer');
export const documentDesignerDesign = documentDesigner.command('Design');
export const documentDesignerEditSettings = documentDesigner.command('Edit Settings');
export const documentDesignerExportForCore = documentDesigner.command('Export for Core');
export const documentDesignerMockData = documentDesigner.command('Mock Data');
export const documentDesignerPublish = documentDesigner.command('Publish');
export const documentDesignerView = documentDesigner.command('View');
export const employees = maintenance.tool('Employees');
export const employeesActivate = employees.command('Activate');
export const employeesEmployeeInformation = employees.command(
  'Employee Information',
  {
    description: 'Open and edit the Employee Information section of an employee record.',
  },
);
export const employeesGroupingRoles = employees.command(
  'Grouping Roles',
  {
    description: 'Open and edit the Grouping Roles section of an employee record.',
  },
);
export const employeesInactivate = employees.command('Inactivate');
export const employeesIntegration = employees.command(
  'Integration',
  {
    description: 'Open and edit the Integration section of an employee record.',
  },
);
export const employeesLoginInformation = employees.command(
  'Login Information',
  {
    description: 'Open and edit the Login Information section (user name, password) of an employee record.',
  },
);
export const employeesSecurityRoles = employees.command(
  'Security Roles',
  {
    description: 'Open and edit the Security Roles section of an employee record.',
  },
);
export const employeesView = employees.command('View');
export const employeesWriteEmployee = employees.command('WriteEmployee');
export const gameDays = maintenance.tool('Game Days');
export const gameDaysLockGameDay = gameDays.command(
  'Lock Game Day',
  {
    description: 'Lock a range of past game days so their transactions can no longer be changed.',
  },
);
export const gameDaysUnlockGameDay = gameDays.command(
  'Unlock Game Day',
  {
    description: 'Unlock previously locked game days so their transactions can be changed again.',
  },
);
export const glAccountCodes = maintenance.tool('GL Account Codes');
export const glAccountCodesActivateInactivateGlAccountCode = glAccountCodes.command('Activate/Inactivate GL Account Code');
export const glAccountCodesAllowGlobalRecords = glAccountCodes.command('Allow Global Records');
export const glAccountCodesAttributesGlAccountCode = glAccountCodes.command('Attributes GL Account Code');
export const glAccountCodesCreateGlAccountCode = glAccountCodes.command('Create GL Account Code');
export const glAccountCodesDuplicateGlAccountCode = glAccountCodes.command('Duplicate GL Account Code');
export const glAccountCodesEditGlAccountCode = glAccountCodes.command('Edit GL Account Code');
export const glAccountCodesEditSystemAccountCodes = glAccountCodes.command('Edit System Account Codes');
export const glAccountCodesMapping = glAccountCodes.command('Mapping');
export const machineSettings = maintenance.tool('Machine Settings');
export const machineSettingsEditMachineSetting = machineSettings.command('Edit Machine Setting');
// Revenue Centers: legacy `RevenueCenterMaintenanceCommand.cs` paths (2026-10-12; replaced the Nova-only
// `Revenue Center Maintenance\View|WriteRevenueCenter|DeleteRevenueCenter`). Each editor tab is gated
// by its own legacy path. Legacy had no delete, so `Delete Revenue Center` is Nova-only, named the way
// legacy's `DeleteEntityCommandBase` would have named it. Legacy's Offsets and Transaction Types tab
// paths are not declared: Nova has no route that edits either. `Attributes Revenue Center` is legacy's
// `AttributesRevenueCenterMaintenanceCommand` path (RevenueCenterMaintenanceCommand.cs:24, 234-240); it gates
// editing a revenue center's attributes in the Attributes tab, as GL Account Codes' and Deposit Categories' do.
export const revenueCenters = maintenance.tool('Revenue Centers');
export const revenueCentersActivateInactivateRevenueCenter = revenueCenters.command('Activate/Inactivate Revenue Center');
export const revenueCentersAttributesRevenueCenter = revenueCenters.command('Attributes Revenue Center');
export const revenueCentersCreateRevenueCenter = revenueCenters.command('Create Revenue Center');
export const revenueCentersDeleteRevenueCenter = revenueCenters.command('Delete Revenue Center', {
  description: 'Delete a revenue center permanently. Nova-only: legacy could only inactivate one.',
});
export const revenueCentersDepositCategories = revenueCenters.command('Deposit Categories');
export const revenueCentersEditRevenueCenter = revenueCenters.command('Edit Revenue Center');
export const revenueCentersOtherCalculatorItems = revenueCenters.command('Other Calculator Items');
export const revenueCentersShifts = revenueCenters.command('Shifts');
export const revenueCentersStations = revenueCenters.command('Stations');
export const roles = maintenance.tool('Roles');
export const rolesActivateInactivateRole = roles.command('Activate/Inactivate Role');
export const rolesDuplicateRole = roles.command('Duplicate Role');
export const rolesPreviewRole = roles.command('Preview Role');
export const securityControls = maintenance.tool(
  'Security Controls',
  {
    description: 'Open the Security Controls tool. Inactivating this path would lock every user out of the tool, so it cannot be inactivated.',
    protectedFromInactivation: true,
  },
);
export const systemOptions = maintenance.tool('System Options');
export const taskStatus = maintenance.tool('Task Status');
export const taskStatusActivateInactivateTaskStatus = taskStatus.command('Activate/Inactivate Task Status');
export const taskStatusCreateTaskStatus = taskStatus.command('Create Task Status');
export const taskStatusEditTaskStatus = taskStatus.command('Edit Task Status');
export const taskTypes = maintenance.tool('Task Types');
export const taskTypesActivateInactivateTaskType = taskTypes.command('Activate/Inactivate Task Type');
export const taskTypesCreateTaskType = taskTypes.command('Create Task Type');
export const taskTypesDuplicateTaskType = taskTypes.command('Duplicate Task Type');
export const taskTypesEditTaskType = taskTypes.command('Edit Task Type');
export const ticketTypes = maintenance.tool('Ticket Types');
export const ticketTypesCreateTicketType = ticketTypes.command('Create Ticket Type');
export const ticketTypesEditTicketType = ticketTypes.command('Edit Ticket Type');
export const tipPools = maintenance.tool('Tip Pools');
export const tipPoolsActivateInactivateTipPool = tipPools.command('Activate/Inactivate Tip Pool');
export const tipPoolsAttributesTipPool = tipPools.command('Attributes Tip Pool');
export const tipPoolsCreateTipPool = tipPools.command('Create Tip Pool');
export const tipPoolsDuplicateTipPool = tipPools.command('Duplicate Tip Pool');
export const tipPoolsEditTipPool = tipPools.command('Edit Tip Pool');
export const transactionTypes = maintenance.tool('Transaction Types');
export const transactionTypesAttributesTransactionType = transactionTypes.command('Attributes Transaction Type');
export const transactionTypesCreateTransactionType = transactionTypes.command('Create Transaction Type');
export const transactionTypesEditTransactionType = transactionTypes.command('Edit Transaction Type');
export const vaultLocations = maintenance.tool('Vault Locations');
export const vaultLocationsActivateInactivateVaultLocation = vaultLocations.command('Activate/Inactivate Vault Location');
export const vaultLocationsAttributesVaultLocation = vaultLocations.command('Attributes Vault Location');
export const vaultLocationsCreateVaultLocation = vaultLocations.command('Create Vault Location');
export const vaultLocationsEditVaultLocation = vaultLocations.command('Edit Vault Location');
